import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.BudgetsPage.BudgetSettingsPopupContent', {
    title: 'Settings for {budgetName}',
    saveButton: 'Save',
    description: `
        Please select budget check period for ”{name}” budget.{br}{br}
        Please note that all periods are defined based on the start of the financial year which is pulled from {integrationName}.
    `,
});
